<template>
  <v-card class="card-border">
    <v-card-text>
      <v-btn
        v-if="$ability.can('Adicionar','Leads Supervisor')"
        outlined
        color="blue darken-2"
        rounded
        dark
        depressed
        small
        @click="$refs.dialogFormCreate.show()"
      >
        <v-icon left>mdi-plus-circle</v-icon>Nova Lead
      </v-btn>
      <v-form ref="form">
        <v-row dense align="center">
          <v-col cols="4">
            <SelectEquipesBySupervisor @onChanged="colaboradores = $event; changeSelectEquipe()" />
          </v-col>
          <v-col cols="4">
            <SelectColaboradoresByEquipe
              @onChanged="colaboradoresSelected = $event"
              :colaboradores="colaboradores"
              :disabled="disableSelectColaboradores"
              :multiple="true"
            />
          </v-col>
          <v-col cols="4"></v-col>
          <v-col cols="2">
            <SelectFilterBy @onChanged="filterBy = $event; changeFilterBy($event)" />
          </v-col>
          <v-col cols="2">
            <SelectTemperatura
              @onChanged="temperatura = $event"
              :disabled="disableSelectTemperatura"
              :validate="validateSelectTemperatura"
            />
          </v-col>
          <v-col cols="2">
            <DateMenu
              label="Data Inicio"
              @onChanged="dateStart = $event"
              :disabled="disableSelectDate"
            />
          </v-col>
          <v-col cols="2">
            <DateMenu label="Data Fim" @onChanged="dateEnd = $event" :disabled="disableSelectDate" />
          </v-col>
          <v-col cols="2">
            <v-btn outlined color="blue darken-2" rounded dark depressed small @click="buscar()">
              <v-icon left>mdi-magnify</v-icon>Buscar
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <DialogFormCreate ref="dialogFormCreate" />
  </v-card>
</template>

<script>
import { mapActions } from "vuex";
import { Supervisor } from "@/services/lead";

export default {
  name: "Filtro",

  components: {
    SelectEquipesBySupervisor: () => import("./SelectEquipesBySupervisor"),
    SelectColaboradoresByEquipe: () => import("./SelectColaboradoresByEquipe"),
    SelectFilterBy: () => import("../../components/SelectFilterBy"),
    SelectTemperatura: () => import("@/components/select/SelectTemperatura"),
    DateMenu: () => import("@/components/datepicker/DateMenu"),
    DialogFormCreate: () => import("./DialogFormCreate")
  },

  data() {
    return {
      filterBy: "",
      colaboradores: [],
      colaboradoresSelected: [],
      disableSelectColaboradores: true,
      temperatura: "",
      disableSelectTemperatura: false,
      validateSelectTemperatura: true,
      disableSelectDate: false,
      dateStart: new Date(),
      dateEnd: new Date(),
      serviceLeadsSupervisor: new Supervisor()
    };
  },

  methods: {
    ...mapActions("leads", ["setLeads"]),

    async buscar() {
      try {
        if (this.$refs.form.validate()) {
          if (this.filterBy == "Temperatura") {
            await this.getLeadsByTemperatura();
          } else if (this.filterBy == "Data Criação") {
            await this.getLeadsByDataCriacao();
          } else if (this.filterBy == "Data Proximo Contato") {
            await this.getLeadsByDataProxContato();
          }
        }
        return Promise.resolve();
      } catch (error) {
        this.$toast.error("Erro ao carregar Dados");
        return Promise.reject(error);
      }
    },

    async getLeadsByTemperatura() {
      try {
        const response = await this.serviceLeadsSupervisor.getLeadsByTemperatura(
          this.getCpfColaboradores(),
          this.temperatura
        );
        this.setLeads(response);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },

    async getLeadsByDataCriacao() {
      try {
        const response = await this.serviceLeadsSupervisor.getLeadsByDataCriacao(
          this.getCpfColaboradores(),
          this.dateStart,
          this.dateEnd
        );
        this.setLeads(response);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },

    async getLeadsByDataProxContato() {
      try {
        const response = await this.serviceLeadsSupervisor.getLeadsByDataProxContato(
          this.getCpfColaboradores(),
          this.dateStart,
          this.dateEnd
        );
        this.setLeads(response);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },

    getCpfColaboradores() {
      let cpfs = [];
      for (let i = 0; i < this.colaboradoresSelected.length; i++) {
        cpfs.push(
          ...this.colaboradores.filter(
            colaborador =>
              colaborador.colaborador == this.colaboradoresSelected[i]
          )
        );
      }
      return cpfs;
    },

    changeFilterBy() {
      if (this.filterBy == "Temperatura") {
        this.disableSelectTemperatura = false;
        this.validateSelectTemperatura = true;
        this.disableSelectDate = true;
      } else {
        this.disableSelectTemperatura = true;
        this.validateSelectTemperatura = false;
        this.disableSelectDate = false;
      }
    },

    changeSelectEquipe() {
      this.disableSelectColaboradores = false;
    }
  }
};
</script>
